import RequestPageTwo from "./RequestPageTwo";

const LifeLongMembership = () => {
    return (
        <RequestPageTwo title="Life Long Membership"
            fetchUrl="/get-lifelong-memberships"
            editEndpoint="update-lifelong-memberships"
            deleteEndpoint="lifelong-memberships"
            statusEndpoint="update-lifelong-memberships" />
    );
}

export default LifeLongMembership;
